module.exports = __webpack_public_path__ + "static/media/delete.26d796f3.svg";